import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

const COMPARISON_ROWS = [
  { key: 'comp1', traditional: false, master: true },
  { key: 'comp2', traditional: false, master: true },
  { key: 'comp3', traditional: false, master: true },
  { key: 'comp4', traditional: false, master: true },
  { key: 'comp5', traditional: false, master: true },
  { key: 'comp6', traditional: false, master: true },
];

export default function Comparison() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-32 bg-white">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#F7F8FA] text-[#E53935] text-xs font-semibold tracking-wider uppercase mb-5 border border-gray-100">
              {t('trafficMaster.comparisonTag')}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-[#111111] leading-tight">
              {t('trafficMaster.comparisonTitle')}
            </h2>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden shadow-[0_8px_40px_rgba(0,0,0,0.04)]">
            <div className="grid grid-cols-3 bg-[#F7F8FA] border-b border-gray-200">
              <div className="p-5 md:p-6 font-heading text-sm md:text-base font-bold text-[#111111]">
                {t('trafficMaster.compFeature')}
              </div>
              <div className="p-5 md:p-6 font-heading text-sm md:text-base font-semibold text-gray-500 text-center border-x border-gray-200">
                {t('trafficMaster.compTraditional')}
              </div>
              <div className="p-5 md:p-6 font-heading text-sm md:text-base font-bold text-[#E53935] text-center bg-[#E53935]/5">
                Traffic Master Growth™
              </div>
            </div>

            {COMPARISON_ROWS.map((row, i) => (
              <div key={row.key} className={`grid grid-cols-3 border-b border-gray-100 ${i % 2 === 0 ? 'bg-white' : 'bg-[#F7F8FA]/40'}`}>
                <div className="p-4 md:p-5 text-sm text-[#111111] font-medium flex items-center">
                  {t(`trafficMaster.${row.key}`)}
                </div>
                <div className="p-4 md:p-5 flex items-center justify-center border-x border-gray-100">
                  {row.traditional ? (
                    <div className="w-6 h-6 rounded-full bg-[#E53935]/10 flex items-center justify-center">
                      <i className="ri-check-line text-[#E53935]"></i>
                    </div>
                  ) : (
                    <i className="ri-close-line text-gray-300 text-lg"></i>
                  )}
                </div>
                <div className="p-4 md:p-5 flex items-center justify-center">
                  {row.master ? (
                    <div className="w-6 h-6 rounded-full bg-[#E53935] flex items-center justify-center shadow-[0_2px_8px_rgba(229,57,53,0.3)]">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                  ) : (
                    <i className="ri-close-line text-gray-300 text-lg"></i>
                  )}
                </div>
              </div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}